/**
 * Home's overlays, each marked by its own class on <html> (set by whichever element opens it). While one is open
 * home's bar and panel are inert (`home-view.ts`) and the town's music is silent (`music/town-music.ts`).
 */
export const HOME_OVERLAYS = ['capture-open', 'moments-open', 'legend-open', 'tend-open', 'town-sheet-open', 'invite-open', 'moment-open', 'report-open', 'reminders-open'] as const;

export const homeCovered = (): boolean => HOME_OVERLAYS.some((c) => document.documentElement.classList.contains(c));
